import Loadable from 'react-loadable'
import PageLoading from '@components/PageLoading'

export const Inquiry = Loadable({
    loader: () => import('@pages/Inquiry'),
    loading: PageLoading
})

export const AdminPanel = Loadable({
    loader: () => import('../AdminPanel'),
    loading: PageLoading
})

export const Login = Loadable({
    loader: () => import('../Login'),
    loading: PageLoading
})
